import './easySlider1.7'

const updateSliderIndex = (slider, ix) => slider.siblings('.title-box').find('.section-index').html(ix+1);

// This should only be imported dynamically if $('.comparison-slider') exists,
// which means we don't need to wrap this in jQuery()
export const comparisonSlider = () => {
  $('.comparison-slider').each(function(csix) {
    $(this).easySlider({
      nextText: 'Next >',
      prevText: '< Previous',
      nextId: `cs-next${csix}`,
      prevId: `cs-prev${csix}`,
      nextCallback: updateSliderIndex,
      prevCallback: updateSliderIndex
    });
  });
};